<script lang="ts">
import TextButton from "../../common/TextButton.svelte";
import ToggleTextButton from "../../common/ToggleTextButton.svelte";
import EditorStore, { EditorPlaybackControlOwnership } from "@src/model/Editor.Store";
import MainStore from "@src/model/Main.Store";



export let getControlTarget: () => (HTMLVideoElement|undefined) = () => undefined;

function handlePlay(state: boolean) {
    if (MainStore.getValue().currentExecutingInteractionPoint.getValue()) {
        return false;
    }
    if (!state) {
        // start playing.
        EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.CONTROL;
        getControlTarget()?.play();
    } else {
        // stop playing.
        EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.NONE;
        getControlTarget()?.pause();
    }
    return true;
}

function handleSkip() {
    MainStore.setCurrentExecutingInteractionPoint(undefined);
    EditorStore.getValue().currentPlaybackControlOwnership = EditorPlaybackControlOwnership.CONTROL;
    getControlTarget()?.play();
}


</script>

<div id="ivdemo-editor-playback-control">
    <!-- <TextButton label="REWIND" /> -->
    <ToggleTextButton label="PLAY" label2="PAUSE" onBeforeClick={handlePlay}/>
    <TextButton label="SKIP" onClick={handleSkip}/>
</div>

<style>
    #ivdemo-editor-playback-control {
        text-align: center;
        height: 1rem;
        background-color: black;
        position: fixed;
        right: 0;
        width: 60%;
        bottom: 302px;
    }
</style>

